"use strict";

/**
* Реквизит карточки типа «Ссылка на документ».
*
* @class WebAccess.components.wrappers.form.requisites.Document
* @extends WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {object} data Данные для инициализации реквизита
* @since 5.5.0.1000
*/
(function (global) {

  var Document = global.WA.CMP.wrappers.form.requisites.BaseObjectSelectRequisite.extend({
    className: "Document",

    /**
    * Возвращает признак возможности множественного выбора.
    *
    * @method WebAccess.components.wrappers.form.requisites.Document#isMultiselect
    * @return {boolean} True - реквизит поддерживает множественный выбор, иначе - False.
	* @since 5.4.0.1013
    */
    isMultiselect: function () {
      return false;
    },

    /**
    * Установить значение отображаемых и неотображаемых реквизитов.
    *
    * @method WebAccess.components.wrappers.form.requisites.Document#setValue
    * @param value {string} Устанавливаемое значение
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {string} Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Document} Текущий объект реквизита – Document.
    * @since 5.5.0.9000
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult, opt_leadRequisiteValues) {
      var me = this;
      var baseSetValue = me._super;
      me._super(value, opt_displayValue, opt_needTriggerResult, opt_leadRequisiteValues);

      if (!opt_displayValue && !me.hasCalculation) {
        if (value) {
          WA.SRV.document.getNameById([value]).done(function (res) {
            baseSetValue.apply(me, [value, res, false, false]);
          }).fail(function (message) {
            baseSetValue.apply(me, [value, message, false, false]);
          });
        }
      }

      return me;
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.WA.CMP.wrappers.form.requisites.Document = Document;
})(window);